import { Box, Heading, IconButton, Menu, MenuButton, MenuItem, MenuList } from '@chakra-ui/react';
import { memo, ReactNode } from 'react';
import { FaFilter } from 'react-icons/fa6';
import { MdCloudDownload, MdAdd } from 'react-icons/md';

import { TableCreateMenuItem } from '../types';

type TableHeaderProps = {
  title: ReactNode;
  disabled?: boolean;
  additionalToolbar?: ReactNode;
  secondaryToolbar?: ReactNode;
  createMenu?: TableCreateMenuItem[];
  onFilterClick?(): void;
  onDownloadClick?(): void;
  onCreateClick?(item?: TableCreateMenuItem): void;
}

const TableHeaderComponent = ({ title, disabled, createMenu, onFilterClick, onDownloadClick, onCreateClick, additionalToolbar, secondaryToolbar }: TableHeaderProps) => {
  return <Box 
    px={6}
    py={4}
  >
    <Box display='flex' justifyContent='space-between' alignItems='center' gap={4}>
      <Heading as='h1' flex={1} size='md' fontWeight={500}>{title}</Heading>
      <Box display='flex' gap={2} flexWrap={additionalToolbar ? 'wrap' : 'nowrap'}>
        {onFilterClick && <IconButton isDisabled={disabled} icon={<FaFilter />} aria-label="filter" onClick={onFilterClick} />}
        {onDownloadClick && <IconButton isDisabled={disabled} icon={<MdCloudDownload />} aria-label="download" onClick={onDownloadClick} />}
        {onCreateClick && !createMenu && <IconButton isDisabled={disabled} icon={<MdAdd fill='white' size={24} />} colorScheme="brand" aria-label="create" onClick={() => onCreateClick()} />}
        {onCreateClick && createMenu && <Menu>
          <MenuButton
            isDisabled={disabled}
            as={IconButton}
            aria-label='Options'
            colorScheme="brand"
            icon={<MdAdd fill='white' size={24} />}
          />
          <MenuList>
            {createMenu.map(({ id, title, icon }) => <MenuItem 
              key={id} 
              onClick={() => onCreateClick({ id, title })}
              icon={icon}
            >

              {title}
            </MenuItem>)}
          </MenuList>
        </Menu>}
        {additionalToolbar}
      </Box>
    </Box>
    {secondaryToolbar}
  </Box>;
};

export const TableHeader = memo(TableHeaderComponent);